<template>
  <div class="assinaturas">
    <div class="items">
      <div class="m75">

        <div class="bd-top">
          <p class="p-align">
            <strong>Homologado por:</strong> <br/>
            {{ assinaturas.homologation_user.nome }}
          </p>
          <p>
           <strong> Matricula:</strong><br/>
            {{ assinaturas.homologation_user.matricula }}
          </p>

          <p class="p-align">
            <strong>Cargo:</strong><br/>
            {{ assinaturas.homologation_user.cargo }}
          </p>
          <p>

            <strong> Homologado em: </strong> <br />
            {{ formatData(assinaturas.homolog_at) }}
          
          </p>
        </div>

        <!-- <div class="bd-top bd-right">
          <div class="criado">
              Criado por:
              {{ assinaturas.created_user.nome }},
            
           
              Matricula:
              {{ assinaturas.created_user.matricula }},
           
           
              Cargo:
              {{ assinaturas.created_user.cargo}},
            
              Data:
              {{ assinaturas.created_user.data}}
          
          </div>
        </div> -->
      </div>
  
        <div class="comment">
          <p><strong>Comentário:</strong>{{ this.assinaturas.comentario }}</p>
        </div>
        
   
    </div>
  </div>
</template>

<script>
import { FindRRimHomologada } from "../../../../controllers/RRIM/FindRRimHomologada";
import dayjs from "dayjs";

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  async created() {
    const data = await FindRRimHomologada(this.id);

    this.assinaturas = data.homologacao[0];
  },
  data() {
    return {
      assinaturas: {
        homologation_user: {
          nome: "",
          cargo: "",
          matricula: "",
          data: "",
        },
        created_user: {
          nome: "",
          cargo: "",
          matricula: "",
        },
        homolog_at: "",
        comentario: "",
      },
    };
  },
  methods: {
    formatData(data) {

      const date = dayjs(data).format(' DD/MM/YYYY HH:mm') ;

      return date;
    },
  },
};
</script>

<style scoped>
.criado {
  display: flex;
}

.bd-top {
  width: 100vw;
  padding: 10px;

}

.comment{
  display: flex;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  justify-content:flex-start;
  text-align: left;
}

.p-align {
  margin: 0 15px 0 15px;
}

.comment p {
  padding: 10px;
  width: 100%;
  word-wrap: break-word;
}

</style>